class CartTool extends HTMLElement {
  constructor() {
    super();
    const buttons = this.querySelectorAll('.cartTool-item');
    buttons.forEach((button) => {
      button.addEventListener('click',(event) => {
        const id = event.target.dataset.popup;
        document.getElementById(id).classList.add('show');
        document.querySelector('.previewCart').classList.add('active-tool');
      })
    })
  }
}

customElements.define('cart-item-tool', CartTool);

class CartCancel extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('button').addEventListener('click',(event) => {
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-cancel-popup', CartCancel);

class CartNote extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('[data-update-note]').addEventListener('click', (event) => {
      this.val = this.querySelector('.text-area').value;
      const body = JSON.stringify({ note: this.val });
      fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-note', CartNote);

class CouponCode extends HTMLElement {
  constructor() {
    super();
    if (localStorage.getItem('storedDiscount')){
      this.querySelector('input[name="discount"]').value = localStorage.getItem('storedDiscount');  
    }

    // Inject feedback message element if not already present
    if (!this.querySelector('.coupon-feedback')) {
      const msg = document.createElement('p');
      msg.className = 'coupon-feedback';
      msg.style.cssText = 'margin: 8px 0 0; font-size: 13px; font-weight: 500; display: none;';
      this.appendChild(msg);
    }

    this.querySelector('[data-update-coupon]').addEventListener('click', (event) => {
      this.val = this.querySelector('input[name="discount"]').value.trim();
      const btn = this.querySelector('[data-update-coupon]');
      const feedback = this.querySelector('.coupon-feedback');

      if (!this.val) {
        this._showFeedback(feedback, 'PLEASE ENTER A COUPON CODE.', false);
        return;
      }

      // Loading state
      btn.disabled = true;
      const originalText = btn.textContent;
      btn.textContent = '...';
      this._showFeedback(feedback, '', false, true); // hide while loading

      fetch(`/discount/${encodeURIComponent(this.val)}`)
        .then((response) => {
          // Shopify always returns 200; we detect validity by checking
          // if the discount cookie/session was actually set via a follow-up cart fetch
          return fetch('/cart.js');
        })
        .then((res) => res.json())
        .then((cart) => {
          btn.disabled = false;
          btn.textContent = originalText;

          // A valid code will appear in cart_level_discount_applications or
          // as a line-item discount; check total_discount or discount presence
          const applied = cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0;
          const lineDiscount = cart.items && cart.items.some(i => i.discounts && i.discounts.length > 0);

          if (applied || lineDiscount) {
            localStorage.setItem('storedDiscount', this.val);
            const discountName = applied ? cart.cart_level_discount_applications[0].title : this.val.toUpperCase();
            this._showFeedback(feedback, `✓ "${discountName}" APPLIED SUCCESSFULLY!`, true);
            // Update cart totals in sidebar
            Shopify.getCart((cartData) => { window.sharedFunctions?.updateSidebarCart(cartData); });
          } else {
            // Code was accepted by /discount/ endpoint but had no effect — treat as invalid
            localStorage.removeItem('storedDiscount');
            this._showFeedback(feedback, '✗ INVALID OR EXPIRED COUPON CODE.', false);
          }
        })
        .catch(() => {
          btn.disabled = false;
          btn.textContent = originalText;
          this._showFeedback(feedback, '✗ SOMETHING WENT WRONG. PLEASE TRY AGAIN.', false);
        });
    });
  }

  _showFeedback(el, message, isSuccess, hide = false) {
    if (hide || !message) {
      el.style.display = 'none';
      return;
    }
    el.textContent = message;
    el.style.display = 'block';
    el.style.color = isSuccess ? '#2a7d4f' : '#c12e48';
  }
}

customElements.define('coupon-code', CouponCode);